"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isTabLoading = exports.isTabInitLoading = exports.isTabEmptyData = exports.isTabEmpty = exports.isSectionEmpty = exports.DataAnalyticHelper = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.filter.js");
var _size = _interopRequireDefault(require("lodash/size"));
var _utils = require("@gravity/utils");
var _excluded = ["tabCode", "sectionCode", "list"],
  _excluded2 = ["tabCode", "sectionCode"];
function cov_463nr1z51() {
  var path = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/helper.js";
  var hash = "5eaf85867c6ec4f37a45b219035aad7d42eeec5b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/helper.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 30
        },
        end: {
          line: 5,
          column: 81
        }
      },
      "1": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 81
        }
      },
      "2": {
        start: {
          line: 5,
          column: 55
        },
        end: {
          line: 5,
          column: 80
        }
      },
      "3": {
        start: {
          line: 7,
          column: 26
        },
        end: {
          line: 7,
          column: 94
        }
      },
      "4": {
        start: {
          line: 7,
          column: 33
        },
        end: {
          line: 7,
          column: 94
        }
      },
      "5": {
        start: {
          line: 7,
          column: 70
        },
        end: {
          line: 7,
          column: 93
        }
      },
      "6": {
        start: {
          line: 10,
          column: 28
        },
        end: {
          line: 10,
          column: 96
        }
      },
      "7": {
        start: {
          line: 10,
          column: 35
        },
        end: {
          line: 10,
          column: 96
        }
      },
      "8": {
        start: {
          line: 10,
          column: 71
        },
        end: {
          line: 10,
          column: 95
        }
      },
      "9": {
        start: {
          line: 14,
          column: 32
        },
        end: {
          line: 14,
          column: 75
        }
      },
      "10": {
        start: {
          line: 14,
          column: 39
        },
        end: {
          line: 14,
          column: 75
        }
      },
      "11": {
        start: {
          line: 17,
          column: 30
        },
        end: {
          line: 18,
          column: 53
        }
      },
      "12": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 53
        }
      },
      "13": {
        start: {
          line: 20,
          column: 26
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "14": {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 43,
          column: 1
        }
      },
      "15": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 41,
          column: 3
        }
      },
      "16": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 37,
          column: 39
        }
      },
      "17": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 84
        }
      },
      "18": {
        start: {
          line: 40,
          column: 71
        },
        end: {
          line: 40,
          column: 82
        }
      },
      "19": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 42,
          column: 76
        }
      },
      "20": {
        start: {
          line: 42,
          column: 63
        },
        end: {
          line: 42,
          column: 74
        }
      },
      "21": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "22": {
        start: {
          line: 45,
          column: 19
        },
        end: {
          line: 47,
          column: 49
        }
      },
      "23": {
        start: {
          line: 46,
          column: 17
        },
        end: {
          line: 46,
          column: 42
        }
      },
      "24": {
        start: {
          line: 47,
          column: 21
        },
        end: {
          line: 47,
          column: 43
        }
      },
      "25": {
        start: {
          line: 48,
          column: 15
        },
        end: {
          line: 48,
          column: 24
        }
      },
      "26": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "27": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 35
        }
      },
      "28": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 14
        }
      },
      "29": {
        start: {
          line: 54,
          column: 34
        },
        end: {
          line: 136,
          column: 1
        }
      },
      "30": {
        start: {
          line: 57,
          column: 23
        },
        end: {
          line: 57,
          column: 99
        }
      },
      "31": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 73,
          column: 5
        }
      },
      "32": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 65,
          column: 8
        }
      },
      "33": {
        start: {
          line: 63,
          column: 40
        },
        end: {
          line: 63,
          column: 101
        }
      },
      "34": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 72,
          column: 8
        }
      },
      "35": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 40
        }
      },
      "36": {
        start: {
          line: 79,
          column: 23
        },
        end: {
          line: 79,
          column: 99
        }
      },
      "37": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "38": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 87,
          column: 7
        }
      },
      "39": {
        start: {
          line: 85,
          column: 40
        },
        end: {
          line: 85,
          column: 99
        }
      },
      "40": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 96,
          column: 7
        }
      },
      "41": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 40
        }
      },
      "42": {
        start: {
          line: 102,
          column: 28
        },
        end: {
          line: 102,
          column: 32
        }
      },
      "43": {
        start: {
          line: 103,
          column: 23
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "44": {
        start: {
          line: 109,
          column: 22
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "45": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 40
        }
      },
      "46": {
        start: {
          line: 124,
          column: 23
        },
        end: {
          line: 124,
          column: 99
        }
      },
      "47": {
        start: {
          line: 125,
          column: 22
        },
        end: {
          line: 132,
          column: 5
        }
      },
      "48": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 30
          },
          end: {
            line: 4,
            column: 31
          }
        },
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 81
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 5,
            column: 44
          },
          end: {
            line: 5,
            column: 45
          }
        },
        loc: {
          start: {
            line: 5,
            column: 55
          },
          end: {
            line: 5,
            column: 80
          }
        },
        line: 5
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 7,
            column: 26
          },
          end: {
            line: 7,
            column: 27
          }
        },
        loc: {
          start: {
            line: 7,
            column: 33
          },
          end: {
            line: 7,
            column: 94
          }
        },
        line: 7
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 7,
            column: 59
          },
          end: {
            line: 7,
            column: 60
          }
        },
        loc: {
          start: {
            line: 7,
            column: 70
          },
          end: {
            line: 7,
            column: 93
          }
        },
        line: 7
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 29
          }
        },
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 96
          }
        },
        line: 10
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 10,
            column: 60
          },
          end: {
            line: 10,
            column: 61
          }
        },
        loc: {
          start: {
            line: 10,
            column: 71
          },
          end: {
            line: 10,
            column: 95
          }
        },
        line: 10
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 14,
            column: 32
          },
          end: {
            line: 14,
            column: 33
          }
        },
        loc: {
          start: {
            line: 14,
            column: 39
          },
          end: {
            line: 14,
            column: 75
          }
        },
        line: 14
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 17,
            column: 30
          },
          end: {
            line: 17,
            column: 31
          }
        },
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 53
          }
        },
        line: 18
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 31,
            column: 19
          },
          end: {
            line: 31,
            column: 20
          }
        },
        loc: {
          start: {
            line: 31,
            column: 46
          },
          end: {
            line: 43,
            column: 1
          }
        },
        line: 31
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        },
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 37,
            column: 39
          }
        },
        line: 35
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 40,
            column: 19
          },
          end: {
            line: 40,
            column: 20
          }
        },
        loc: {
          start: {
            line: 40,
            column: 71
          },
          end: {
            line: 40,
            column: 82
          }
        },
        line: 40
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 42,
            column: 17
          },
          end: {
            line: 42,
            column: 18
          }
        },
        loc: {
          start: {
            line: 42,
            column: 63
          },
          end: {
            line: 42,
            column: 74
          }
        },
        line: 42
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 44,
            column: 20
          },
          end: {
            line: 44,
            column: 21
          }
        },
        loc: {
          start: {
            line: 44,
            column: 41
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 44
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 46,
            column: 11
          }
        },
        loc: {
          start: {
            line: 46,
            column: 17
          },
          end: {
            line: 46,
            column: 42
          }
        },
        line: 46
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 47,
            column: 10
          },
          end: {
            line: 47,
            column: 11
          }
        },
        loc: {
          start: {
            line: 47,
            column: 21
          },
          end: {
            line: 47,
            column: 43
          }
        },
        line: 47
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 56,
            column: 24
          },
          end: {
            line: 56,
            column: 25
          }
        },
        loc: {
          start: {
            line: 56,
            column: 48
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 56
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 63,
            column: 32
          },
          end: {
            line: 63,
            column: 33
          }
        },
        loc: {
          start: {
            line: 63,
            column: 40
          },
          end: {
            line: 63,
            column: 101
          }
        },
        line: 63
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 78,
            column: 26
          },
          end: {
            line: 78,
            column: 27
          }
        },
        loc: {
          start: {
            line: 78,
            column: 50
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 78
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 85,
            column: 32
          },
          end: {
            line: 85,
            column: 33
          }
        },
        loc: {
          start: {
            line: 85,
            column: 40
          },
          end: {
            line: 85,
            column: 99
          }
        },
        line: 85
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 101,
            column: 19
          },
          end: {
            line: 101,
            column: 20
          }
        },
        loc: {
          start: {
            line: 101,
            column: 35
          },
          end: {
            line: 121,
            column: 3
          }
        },
        line: 101
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 123,
            column: 22
          },
          end: {
            line: 123,
            column: 23
          }
        },
        loc: {
          start: {
            line: 123,
            column: 38
          },
          end: {
            line: 134,
            column: 3
          }
        },
        line: 123
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 9
          }
        }, {
          start: {
            line: 5,
            column: 13
          },
          end: {
            line: 5,
            column: 81
          }
        }],
        line: 5
      },
      "1": {
        loc: {
          start: {
            line: 5,
            column: 14
          },
          end: {
            line: 5,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 5,
            column: 14
          },
          end: {
            line: 5,
            column: 30
          }
        }, {
          start: {
            line: 5,
            column: 34
          },
          end: {
            line: 5,
            column: 36
          }
        }],
        line: 5
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 33
          },
          end: {
            line: 7,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 33
          },
          end: {
            line: 7,
            column: 36
          }
        }, {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 7,
            column: 94
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 38
          }
        }, {
          start: {
            line: 10,
            column: 42
          },
          end: {
            line: 10,
            column: 96
          }
        }],
        line: 10
      },
      "4": {
        loc: {
          start: {
            line: 14,
            column: 39
          },
          end: {
            line: 14,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 39
          },
          end: {
            line: 14,
            column: 56
          }
        }, {
          start: {
            line: 14,
            column: 60
          },
          end: {
            line: 14,
            column: 75
          }
        }],
        line: 14
      },
      "5": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 12
          }
        }, {
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 34
          }
        }, {
          start: {
            line: 18,
            column: 38
          },
          end: {
            line: 18,
            column: 53
          }
        }],
        line: 18
      },
      "6": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 32
      },
      "7": {
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 37,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 43
          }
        }, {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 47
          }
        }, {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 39
          }
        }],
        line: 35
      },
      "8": {
        loc: {
          start: {
            line: 46,
            column: 17
          },
          end: {
            line: 46,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 17
          },
          end: {
            line: 46,
            column: 24
          }
        }, {
          start: {
            line: 46,
            column: 28
          },
          end: {
            line: 46,
            column: 42
          }
        }],
        line: 46
      },
      "9": {
        loc: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 49
      },
      "10": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        }, {
          start: {
            line: 66,
            column: 11
          },
          end: {
            line: 73,
            column: 5
          }
        }],
        line: 59
      },
      "11": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        }, {
          start: {
            line: 88,
            column: 11
          },
          end: {
            line: 97,
            column: 5
          }
        }],
        line: 81
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5eaf85867c6ec4f37a45b219035aad7d42eeec5b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_463nr1z51 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_463nr1z51();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
cov_463nr1z51().s[0]++;
var isSectionEmpty = exports.isSectionEmpty = function isSectionEmpty(section) {
  cov_463nr1z51().f[0]++;
  cov_463nr1z51().s[1]++;
  return (cov_463nr1z51().b[0][0]++, section) && (cov_463nr1z51().b[0][1]++, ((cov_463nr1z51().b[1][0]++, section.clusters) || (cov_463nr1z51().b[1][1]++, [])).every(function (cluster) {
    cov_463nr1z51().f[1]++;
    cov_463nr1z51().s[2]++;
    return (0, _size.default)(cluster.items) === 0;
  }));
};
cov_463nr1z51().s[3]++;
var isTabEmpty = exports.isTabEmpty = function isTabEmpty(tab) {
  cov_463nr1z51().f[2]++;
  cov_463nr1z51().s[4]++;
  return (cov_463nr1z51().b[2][0]++, tab) && (cov_463nr1z51().b[2][1]++, tab.sections.every(function (section) {
    cov_463nr1z51().f[3]++;
    cov_463nr1z51().s[5]++;
    return isSectionEmpty(section);
  }));
};

/* Check loading state of all section inside tab */
cov_463nr1z51().s[6]++;
var isTabLoading = exports.isTabLoading = function isTabLoading(tab) {
  cov_463nr1z51().f[4]++;
  cov_463nr1z51().s[7]++;
  return (cov_463nr1z51().b[3][0]++, tab) && (cov_463nr1z51().b[3][1]++, tab.sections.some(function (section) {
    cov_463nr1z51().f[5]++;
    cov_463nr1z51().s[8]++;
    return section.LOADING === true;
  }));
};

// Detect tab is loading for the first time to show loading indicator
// Each section of tab have it own loading => just need to show loading when init
cov_463nr1z51().s[9]++;
var isTabInitLoading = exports.isTabInitLoading = function isTabInitLoading(tab) {
  cov_463nr1z51().f[6]++;
  cov_463nr1z51().s[10]++;
  return (cov_463nr1z51().b[4][0]++, isTabLoading(tab)) && (cov_463nr1z51().b[4][1]++, isTabEmpty(tab));
};

// Detect tab do not have any data (all section empty)
cov_463nr1z51().s[11]++;
var isTabEmptyData = exports.isTabEmptyData = function isTabEmptyData(tab, isLoading) {
  cov_463nr1z51().f[7]++;
  cov_463nr1z51().s[12]++;
  return (cov_463nr1z51().b[5][0]++, !isLoading) && (cov_463nr1z51().b[5][1]++, !isTabLoading(tab)) && (cov_463nr1z51().b[5][2]++, isTabEmpty(tab));
};
var ANALYTIC_PROPERTY = (cov_463nr1z51().s[13]++, {
  TAB_CODE: 'tabCode',
  SECTION_CODE: 'sectionCode',
  LIST: 'list'
});

/*
  * Use to remove unwanted properties from all objects in an array
  * @param {Array} arr: array contains objects that need remove
  * @param {String} propsToRemove properties that will be removed from object
  */
cov_463nr1z51().s[14]++;
var removeProp = function removeProp(arr) {
  cov_463nr1z51().f[8]++;
  cov_463nr1z51().s[15]++;
  for (var _len = arguments.length, propsToRemove = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    propsToRemove[_key - 1] = arguments[_key];
  }
  if (propsToRemove.every(function (prop) {
    cov_463nr1z51().f[9]++;
    cov_463nr1z51().s[16]++;
    return (cov_463nr1z51().b[7][0]++, prop === ANALYTIC_PROPERTY.TAB_CODE) && (cov_463nr1z51().b[7][1]++, prop === ANALYTIC_PROPERTY.SECTION_CODE) && (cov_463nr1z51().b[7][2]++, prop === ANALYTIC_PROPERTY.LIST);
  })) {
    cov_463nr1z51().b[6][0]++;
    cov_463nr1z51().s[17]++;
    return arr.map(function (_ref) {
      var tabCode = _ref.tabCode,
        sectionCode = _ref.sectionCode,
        list = _ref.list,
        propsToKeep = (0, _objectWithoutProperties2.default)(_ref, _excluded);
      cov_463nr1z51().f[10]++;
      cov_463nr1z51().s[18]++;
      return propsToKeep;
    });
  } else {
    cov_463nr1z51().b[6][1]++;
  }
  cov_463nr1z51().s[19]++;
  return arr.map(function (_ref2) {
    var tabCode = _ref2.tabCode,
      sectionCode = _ref2.sectionCode,
      propsToKeep = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
    cov_463nr1z51().f[11]++;
    cov_463nr1z51().s[20]++;
    return propsToKeep;
  });
};
cov_463nr1z51().s[21]++;
var addUserInfo = function addUserInfo(dataLayer, user) {
  cov_463nr1z51().f[12]++;
  var userData = (cov_463nr1z51().s[22]++, (0, _keys.default)(user).filter(function (k) {
    cov_463nr1z51().f[13]++;
    cov_463nr1z51().s[23]++;
    return (cov_463nr1z51().b[8][0]++, user[k]) && (cov_463nr1z51().b[8][1]++, user[k] !== '');
  }).reduce(function (a, k) {
    cov_463nr1z51().f[14]++;
    cov_463nr1z51().s[24]++;
    return _objectSpread(_objectSpread({}, a), {}, (0, _defineProperty2.default)({}, k, user[k]));
  }, {}));
  var data = (cov_463nr1z51().s[25]++, dataLayer);
  cov_463nr1z51().s[26]++;
  if ((0, _keys.default)(userData).length > 0) {
    cov_463nr1z51().b[9][0]++;
    cov_463nr1z51().s[27]++;
    data.ecommerce.user = userData;
  } else {
    cov_463nr1z51().b[9][1]++;
  }
  cov_463nr1z51().s[28]++;
  return data;
};
var DataAnalyticHelper = exports.DataAnalyticHelper = (cov_463nr1z51().s[29]++, {
  getProductImpression: function getProductImpression(data, user, useGA4) {
    cov_463nr1z51().f[15]++;
    var dataToPush = (cov_463nr1z51().s[30]++, removeProp(data, ANALYTIC_PROPERTY.TAB_CODE, ANALYTIC_PROPERTY.SECTION_CODE));
    var dataLayer;
    cov_463nr1z51().s[31]++;
    if (useGA4) {
      cov_463nr1z51().b[10][0]++;
      cov_463nr1z51().s[32]++;
      dataLayer = {
        event: 'view_item_list',
        ecommerce: {
          items: dataToPush.map(function (d) {
            cov_463nr1z51().f[16]++;
            cov_463nr1z51().s[33]++;
            return _objectSpread({}, (0, _utils.convertToGA4Attribute)(_utils.GA4EventEnum.productImpression, d));
          })
        }
      };
    } else {
      cov_463nr1z51().b[10][1]++;
      cov_463nr1z51().s[34]++;
      dataLayer = {
        event: 'ee-productImpression',
        ecommerce: {
          impression: (0, _toConsumableArray2.default)(dataToPush)
        }
      };
    }
    cov_463nr1z51().s[35]++;
    return addUserInfo(dataLayer, user);
  },
  getPromotionImpression: function getPromotionImpression(data, user, useGA4) {
    cov_463nr1z51().f[17]++;
    var dataToPush = (cov_463nr1z51().s[36]++, removeProp(data, ANALYTIC_PROPERTY.TAB_CODE, ANALYTIC_PROPERTY.SECTION_CODE));
    var dataLayer;
    cov_463nr1z51().s[37]++;
    if (useGA4) {
      cov_463nr1z51().b[11][0]++;
      cov_463nr1z51().s[38]++;
      dataLayer = {
        event: 'view_promotion',
        ecommerce: {
          items: dataToPush.map(function (d) {
            cov_463nr1z51().f[18]++;
            cov_463nr1z51().s[39]++;
            return _objectSpread({}, (0, _utils.convertToGA4Attribute)(_utils.GA4EventEnum.promoImpression, d));
          })
        }
      };
    } else {
      cov_463nr1z51().b[11][1]++;
      cov_463nr1z51().s[40]++;
      dataLayer = {
        event: 'ee-promoImpression',
        ecommerce: {
          promoView: {
            promotions: (0, _toConsumableArray2.default)(dataToPush)
          }
        }
      };
    }
    cov_463nr1z51().s[41]++;
    return addUserInfo(dataLayer, user);
  },
  getProductClick: function getProductClick(data, user) {
    cov_463nr1z51().f[19]++;
    var _ref3 = (cov_463nr1z51().s[42]++, data),
      topic = _ref3.list;
    var dataToPush = (cov_463nr1z51().s[43]++, removeProp(data, ANALYTIC_PROPERTY.LIST, ANALYTIC_PROPERTY.TAB_CODE, ANALYTIC_PROPERTY.SECTION_CODE));
    var dataLayer = (cov_463nr1z51().s[44]++, {
      event: 'ee-productClick',
      ecommerce: {
        click: {
          actionField: {
            list: topic
          },
          products: (0, _toConsumableArray2.default)(dataToPush)
        }
      }
    });
    cov_463nr1z51().s[45]++;
    return addUserInfo(dataLayer, user);
  },
  getPromotionsClick: function getPromotionsClick(data, user) {
    cov_463nr1z51().f[20]++;
    var dataToPush = (cov_463nr1z51().s[46]++, removeProp(data, ANALYTIC_PROPERTY.TAB_CODE, ANALYTIC_PROPERTY.SECTION_CODE));
    var dataLayer = (cov_463nr1z51().s[47]++, {
      event: 'ee-promoClick',
      ecommerce: {
        promoClick: {
          promotions: (0, _toConsumableArray2.default)(dataToPush)
        }
      }
    });
    cov_463nr1z51().s[48]++;
    return addUserInfo(dataLayer, user);
  }
});